import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer, RaikoGridOneColumn,
    RaikoGridTwoColumn, RaikoMaterialOutlinedInput, RaikoNumberInputOutlined,
    RaikoSectionContainer, RaikoToggleOutlined,
    showErrorMessage, showSuccessMessage, showWarningMessage, RaikoCreatorInfo
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {GroupsService} from "../../../serverService/groups/GroupsService";
import {useAuthState} from "../../../context/AuthContext";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import GroupManagerDetail from "./GroupManagerDetail";
import {css} from "@emotion/css";

export default function GroupDetailInfo() {

    const {id: groupId} = useParams()

    const [groupName, setGroupName] = useState("")
    const [groupCode, setGroupCode] = useState("");
    const [enabled, setEnabled] = useState(false)

    const [createdAt, setCreatedAt] = useState("");
    const [createdBy, setCreatedBy] = useState("");

    const service = new GroupsService()
    const {fundID} = useAuthState()


    const loading = new LoadingHelper(useLoadingDispatcher())
    const [actionButtonLoading, setActionButtonLoading] = useState(false);

    const [groupManager, setGroupManager] = useState([]);

    useEffect(() => {
        if (groupId && groupId > 0)
            getGroupDetailFromServer()
    }, [groupId]);

    function getGroupDetailFromServer() {
        loading.show()
        service.getGroupsDetail(
            fundID,
            groupId
        ).then(response => {
            setGroupName(response.name)
            setGroupCode(response.code)
            setEnabled(response.enabled)

            setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
            setCreatedBy(response.createdBy)

            if (response.groupLeader) {
                setGroupManager([{
                    id: response.groupLeader.id,
                    name: `${response.groupLeader.firstName} ${response.groupLeader.lastName}`
                }])
            }

        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateInfo() {
        if (checkFields()) {
            setActionButtonLoading(true)
            service.updateGroupInfo(
                fundID,
                groupId,
                groupName,
                groupCode,
                enabled
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                setActionButtonLoading(false)
            })

        }
    }

    function checkFields() {
        let message = ""
        let state = false

        if (groupCode.length === 0)
            message = "لطفا کد گروه را به درستی وارد نمایید."
        else if (groupName.length === 0)
            message = "لطفا نام گروه را به درستی وارد نمایید."
        else
            state = true

        if (message && message.length > 0)
            showWarningMessage(message)

        return state
    }

    return (
        <RaikoGridOneColumn className={css`gap: 1.5rem;`}>

            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پایه"}
                    hasActionButton
                    actionButtonTitle={"بروزرسانی"}
                    actionButtonOnclick={handleUpdateInfo}
                    actionButtonLoadingState={actionButtonLoading}
                >
                    <RaikoGridTwoColumn>
                        <RaikoNumberInputOutlined labelText={"کد گروه"} value={groupCode} setValue={setGroupCode}/>
                        <RaikoMaterialOutlinedInput labelText={"نام گروه"} value={groupName} setValue={setGroupName}/>
                    </RaikoGridTwoColumn>
                    <RaikoToggleOutlined checked={enabled} setChecked={setEnabled} labelText={"فعالسازی"}/>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>
            <GroupManagerDetail
                groupManager={groupManager}
            />


        </RaikoGridOneColumn>

    )
}
